import humps from 'humps';
import axios, { Method } from "axios";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import StorageService from "../service/StorageService";
import HttpStatusCode from "../constants/HttpErrorCode";
import Constants from "../constants/Constants";
export interface IApiResponse {
    readonly status: number;
    readonly body: any;
}
export interface IBodyError {
    readonly errorCode: number;
    readonly message: string
}
// @ts-ignore
let paths: string[] = []

export async function getRequest(path: string, isDelay?: boolean): Promise<IApiResponse> {
    if (paths.find((index) => index === path) &&isDelay) {
        const apiResponse: IApiResponse = {
            status: 500,
            body: undefined
        };
        return apiResponse
    }
    paths.push(path)
    const x=setTimeout(() => {
        clearTimeout(x)
        paths = []
    }, Constants.TIME_TO_REFRESH - 1000)
    
    var newHeaders: any = { 'Content-Type': 'application/json' };
    return await axios.get(Constants.API_URL + path, { headers: newHeaders })
        .then(
            (response) => {
                const apiResponse: IApiResponse = {
                    status: response.status,
                    body: humps.camelizeKeys(response.data),
                };
                return apiResponse;
            },
            (error) => {
                let bodyError: IBodyError;
                try {
                    bodyError = {
                        errorCode: error.response.data.errorCode,
                        message: error.response.data.message
                    }
                    const apiResponse: IApiResponse = {
                        status: error.response.status,
                        body: bodyError
                    };
                    return apiResponse;
                } catch (e) {
                    bodyError = {
                        errorCode: HttpStatusCode.UNKNOW_ERROR,
                        message: "Unknow error, please try again later"
                    }
                    const apiResponse: IApiResponse = {
                        status:500,
                        body: bodyError
                    };
                    return apiResponse;
                }
                
            }
        );
}


export async function postRequest(path: string, params: object): Promise<IApiResponse> {
    return apiCall(path, "POST", params);
}

export function apiCall(path: string, _method: Method = "POST", _params: object): Promise<IApiResponse> {
    var newHeaders: any = { 'Content-Type': 'application/json' };
    return new Promise<IApiResponse>((resolve) => {
        axios({
            data: _params, //JSON.stringify(_params),
            headers: newHeaders,
            method: _method,
            url: Constants.API_URL + path
        })
            .then(function (response) {
                resolve({
                    status: response.status,
                    body: humps.camelizeKeys(response.data),
                });
            })
            .catch(function (error) {
                // if (error.response && error.response.status === HttpStatusCode.UNAUTHORIZED || error.response.data.message == "Invalid authentication 4") {
                //     toastUtil.error('Token expire');
                //     StorageService.removeToken();
                //     window.location.href = "/"
                // }

                let bodyError: IBodyError;
                try {
                    if (error.response && error.response.status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
                        bodyError = {
                            errorCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
                            message: "Internal server error, please try again later"
                        }
                    } else {
                        bodyError = {
                            errorCode: error.response.data.errorCode,
                            message: error.response.data.message
                        }
                    }

                } catch (e) {
                    bodyError = {
                        errorCode: HttpStatusCode.UNKNOW_ERROR,
                        message: "Unknow error, please try again later"
                    }
                }
                const apiResponse: IApiResponse = {
                    status: error.response.status,
                    body: bodyError
                };
                resolve(apiResponse);
            });

    });
}

export async function putRequest(path: string, params: object): Promise<IApiResponse> {
    return apiCall(path, "PUT", params);
}
export async function deleteRequest(path: string, params: object): Promise<IApiResponse> {
    return apiCall(path, "DELETE", params);
}
